import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartModule } from 'angular-highcharts';
import { AssistantChartComponent } from './assistant-chart.component';
import { AssistantChatComponent } from './assistant-chat.component';
import { AssistantQuestionComponent } from './assistant-question.component';
import { AssistantTableComponent } from './assistant-table.component';

@NgModule({
    declarations: [
        AssistantChatComponent,
        AssistantChartComponent,
        AssistantQuestionComponent,
        AssistantTableComponent,
    ],
    exports: [AssistantChatComponent],
    imports: [CommonModule, FormsModule, RouterModule, ChartModule],
})
export class FeatureAssistantChatModule {}
